import { map, defaultArg } from "../.fable/fable-library.3.1.4/Option.js";
import { Auto_unsafeFromString_Z5CB6BD } from "../.fable/Thoth.Json.4.1.0/Decode.fs.js";
import { Termin$reflection } from "../Domain.fs.js";
import { list_type } from "../.fable/fable-library.3.1.4/Reflection.js";
import { empty } from "../.fable/fable-library.3.1.4/List.js";
import { Auto_toString_5A41365E } from "../.fable/Thoth.Json.4.1.0/Encode.fs.js";

const storage = localStorage;

export function Termine_get() {
    let _arg1;
    return defaultArg(map((json) => Auto_unsafeFromString_Z5CB6BD(json, void 0, void 0, {
        ResolveType: () => list_type(Termin$reflection()),
    }), (_arg1 = storage.getItem("Schedule"), (_arg1 === null) ? (void 0) : _arg1)), empty());
}

export function Termine_set(v) {
    storage.setItem("Schedule", Auto_toString_5A41365E(0, v, void 0, void 0, void 0, {
        ResolveType: () => list_type(Termin$reflection()),
    }));
}

